@let contactTenantRoute = this.contactTenantRoute$ | async;
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    @if (contactTenantRoute && this.display() === 'icon') {
      <cam-font-icon
        [name]="'arrow-big-right'"
        type="lg"
        (click)="this.navigateToTenantContact(contactTenantRoute)"
      ></cam-font-icon>
    } @else if (contactTenantRoute && this.display() === 'button') {
      <cam-button [type]="'secondary'" (action)="this.navigateToTenantContact(contactTenantRoute)">
        <ng-content></ng-content>
      </cam-button>
    }
  </cam-error>
</cam-loader>
